import { createContext, useEffect, useState } from "react"
import themeStoragre from "../functions/themeStoragre";
export let Theme_context = createContext();
export default function ThemeContext({children}) {
let [theme,setTheme] = useState();
useEffect(_ => {
  setTheme(themeStoragre('Get'));
},[])
let value_passing = {theme,setTheme};
  return (
   <Theme_context.Provider value={value_passing}>
        {children}
    </Theme_context.Provider>
  )
}
